import React, { useEffect } from 'react';
import {baseURL} from '../lib/apiClient';

const LoginPage = () => {
    useEffect(() => {
        // 컴포넌트 마운트 시 바로 인증 서버 로그인 페이지로 리다이렉트
        window.location.href = `${baseURL}/oauth2/authorization/wm-client`;
    }, []);

    return <div>인증 서버로 이동 중입니다...</div>;
};

export default LoginPage;

